import styles from './TagsEnv.module.css';

export function TagsEnv({ env, isToolDisabledByConnector, className }: { env: 'test' | 'dev' | 'prod' | undefined; isToolDisabledByConnector: boolean; className?: string }) {


    return (
        <div className={`${styles.environment} ${className || ''}`}>
            {
                (isToolDisabledByConnector || !env)
                    ? (
                        <span className={`${styles.environmentBadge} ${styles.environmentInactive}`}>
                            N/A
                        </span>
                    )
                    : (
                        <span className={`${styles.environmentBadge} ${styles[`environment${env}`]}`}>
                            {env === 'test' ? 'Test' : env === 'dev' ? 'Dev' : 'Prod'}
                        </span>
                    )
            }
        </div>
    )
}